// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qn-9";
export var arrowButtonContainer = "_qn-5";
export var arrowButtonIcon = "_qn-6";
export var carouselArrowButton = "_qn-2";
export var carouselElementContainer = "_qn-1";
export var currentSlide = "_qn-8";
export var left = "_qn-3";
export var otherSlide = "_qn-a";
export var productCarouselContainer = "_qn-0";
export var right = "_qn-4";
export var sliderOverflow = "_qn-7";